import React from 'react';

const HRBanner = () => {
  const handleLinkClick = (e) => {
    console.log('Explore Now button clicked', e);
  
    window.location.href = 'https://hrm.emedicals.ng/';
  };

  return (
    <div className="relative w-full bg-gradient-to-r from-blue-600 to-indigo-700 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight mb-4">
          Revolutionize Your HR with Seamless Software
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl mb-6 max-w-2xl mx-auto">
          Streamline hiring, manage payroll, and empower your team with our cutting-edge HR solution.
        </p>
        <a
          href="https://hrm.emedicals.ng/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick}
          className="inline-block bg-white text-blue-600 font-semibold py-3 px-6 rounded-lg shadow-lg hover:bg-gray-100 transition duration-300"
        >
          Explore Now
        </a>
      </div>

    </div>
  );
};

export default HRBanner;